const COMPLIANCE_QUESTION_MAPPING_NUMBERS = ['MVSP2.7.1', 'MVSP2.7.2', 'MVSP2.7.3', 'MVSP2.7.4'];

const COMPLIANCES_QUESTION_MAPPING_NUMBER = 'MVSP2.7.5';

module.exports = {
  COMPLIANCE_QUESTION_MAPPING_NUMBERS,
  COMPLIANCES_QUESTION_MAPPING_NUMBER
};
